package com.rajen.angrejidictionary.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.rajen.angrejidictionary.analytics.GoogleAnalytics
import com.rajen.angrejidictionary.analytics.Umami
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private val TitleColor = Color.rgb(0xD3, 0x35, 0x3E)
private val CardBg = Color.rgb(0xF1, 0xC6, 0xA6)
private val PrimaryText = Color.rgb(0x21, 0x00, 0x00)
private val SecondaryText = Color.rgb(0xB6, 0x9B, 0x8C)

/**
 * Registered as Kobweb's site-wide error page via ctx.router.setErrorPage
 * in AppEntry.kt. Renders for any URL that doesn't match a known route
 * (typos, dead links, old bookmarks). Builds its own Header/Footer shell
 * since it isn't wrapped by PageLayout the way a normal @Page is.
 */
@Composable
fun NotFoundContent() {
    val ctx = rememberPageContext()

    LaunchedEffect(ctx.route.path) {
        document.title = "Angreji Dictionary - Page Not Found"
        Umami.track("route-not-found")
        GoogleAnalytics.pageView(document.title, ctx.route.path)
    }

    Column(
        Modifier
            .fillMaxWidth()
            .height(100.vh)
            .overflow { y(Overflow.Hidden); x(Overflow.Hidden) }
            .backgroundColor(Color.rgb(0xFF, 0xEC, 0xDE)),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Header()

        Box(
            Modifier.fillMaxWidth().flex(1).padding(leftRight = 1.cssRem),
            contentAlignment = Alignment.Center
        ) {
            Column(
                Modifier
                    .fillMaxWidth()
                    .maxWidth(480.px)
                    .backgroundColor(CardBg)
                    .borderRadius(28.px)
                    .padding(2.cssRem),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Span(attrs = Modifier.fontSize(2.6.cssRem).toAttrs()) { Text("🧭") }

                SpanText(
                    "Page Not Found",
                    Modifier.fontSize(1.5.cssRem).fontWeight(FontWeight.Bold)
                        .color(PrimaryText).margin(top = 1.cssRem)
                )

                SpanText(
                    "We couldn't find the page you were looking for. It may have been moved, or the link might be outdated.",
                    Modifier.fontSize(0.95.cssRem).color(SecondaryText)
                        .textAlign(TextAlign.Center).lineHeight(1.6)
                        .margin(top = 0.6.cssRem)
                )

                Box(
                    Modifier
                        .margin(top = 1.6.cssRem)
                        .backgroundColor(TitleColor)
                        .borderRadius(999.px)
                        .padding(topBottom = 10.px, leftRight = 26.px)
                        .cursor(Cursor.Pointer)
                        .onClick { ctx.router.navigateTo("/") }
                ) {
                    SpanText(
                        "🏠 Go to Home",
                        Modifier.fontSize(0.9.cssRem).fontWeight(FontWeight.Bold)
                            .color(Color.rgb(0xFF, 0xFF, 0xFF))
                    )
                }
            }
        }

        Footer(Modifier.fillMaxWidth())
    }
}